import React, {createContext, useContext, useState} from "react";
import {SchoolUser} from "../types";

interface UserContextType {
    user: SchoolUser | null;
    setUser: React.Dispatch<React.SetStateAction<SchoolUser | null>>;
    updateUser: (details: Partial<SchoolUser>) => void;
}

export const UserContext = createContext<UserContextType | null>(null);

export const UserContextProvider = ({ children }: { children: React.ReactNode }) => {
    // Fix: was useState([]) but user is an object, not an array
    const [user, setUser] = useState<SchoolUser | null>(null);

    const updateUser = (details: Partial<SchoolUser>) => {
        setUser(previousState => {
            if (!previousState) return previousState;
            return { ...previousState, ...details };
        });
    };

    const value = {user, setUser, updateUser};

    return (
        <UserContext.Provider value={value}> {children} </UserContext.Provider>
    );
};

export default UserContext;

export const useUser = (): UserContextType => {
    const ctx = useContext(UserContext);
    if (!ctx) throw new Error('useUser must be used within UserContextProvider');
    return ctx;
};
